import request from '../helper/request'

// ========== 获取产品列表 ==========
// 获取产品列表（分页）
export function getProductList(params) {
    return request({
      url: '/api/getProductList/',
      method: 'post',
      data: params
    })
  }
  
  // 新增产品（支持文件上传）
  export function addProduct(formData) {
    return request({
      url: '/api/addProduct/',
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
  
  // 更新产品（支持文件上传）
  export function updateProduct(formData) {
    return request({
      url: '/api/updateProduct/',
      method: 'post',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
  
  // 删除产品
  export function deleteProduct(data) {
    return request({
      url: '/api/deleteProduct/',
      method: 'post',
      data
    })
  }

  /**
 * 根据ID获取产品详情
 * @param {number|string} id - 产品ID
 * @returns {Promise}
 */
export function getProductById(id) {
  return request({
    url: "/api/getProductById/",
    method: "post",
    data: { id }
  });
}